<template>
  <div>
    <Sticky>
      <nav
        class="navbar navbar-horizontal navbar-expand-lg navbar-app"
        role="navigation"
        :aria-label="$t('navbar.nav_label')"
      >
        <div class="container-fluid navbar-app-inner">
          <div class="navbar-app-left">
            <button
              v-if="$route.path !== '/auth/login' && $route.path !== '/home'"
              type="button"
              class="navbar-back"
              :aria-label="$t('navbar.go_back')"
              @click="$router.go(-1)"
            >
              <i
                class="fas fa-chevron-left"
                aria-hidden="true"
              ></i>
            </button>
            <button
              type="button"
              class="navbar-logo-wrap"
              :aria-label="$t('navbar.home')"
              @click="$router.push('/home')"
            >
              <img
                src="https://storage.googleapis.com/spacetech2/mdl/logo.png"
                alt=""
                class="navbar-logo"
              />
            </button>
          </div>

          <div
            v-if="$route.path !== '/auth/login' && $store.state.authUser"
            class="navbar-app-right"
          >
            <div
              class="mr-3 pt-2"
              @click="appInstall()"
            >
              <span
                class=" mx-auto"
                style="color: #E8E630; font-size: 10px;"
              >Install</span>
              <img
                class="ml-2 my-auto mx-auto"
                style="width: 2.3rem;"
                src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_install.png"
                alt=""
              >
            </div>
            <div class="navbar-avatar-wrap">
              <img
                class="navbar-avatar"
                :src="$store.state.authUser.gender === 'female'
                  ? 'https://storage.googleapis.com/spacetech2/mdl/Girl%20Profile%20.png'
                  : 'https://storage.googleapis.com/spacetech2/mdl/Boy%20Profile.png'
                  "
                alt=""
              />
            </div>
            <div class="navbar-wallet navbar-wallet--main">
              <span class="navbar-wallet-label">{{ $t('navbar.main_wallet') }}</span>
              <span class="navbar-wallet-row">
                <span class="navbar-wallet-amount">
                  K {{ Number($store.state.authUser.amount).toLocaleString() }}
                </span>
                <button
                  type="button"
                  class="navbar-transfer-btn"
                  :aria-label="$t('navbar.main_wallet_details')"
                  @click="showMainWallet()"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/mdl/Screenshot_2025-03-12_at_1.24.51_PM-removebg-preview.png"
                    alt=""
                  />
                </button>
              </span>
            </div>
            <div class="navbar-wallet navbar-wallet--game">
              <span class="navbar-wallet-label">{{ $t('navbar.game_wallet') }}</span>
              <span class="navbar-wallet-row">
                <span class="navbar-wallet-amount">
                  K {{ Number($store.state.authUser.game_balance).toLocaleString() }}
                </span>
                <button
                  type="button"
                  class="navbar-transfer-btn"
                  :aria-label="$t('navbar.game_wallet_details')"
                  @click="showGameWallet()"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/mdl/Screenshot_2025-03-12_at_1.24.51_PM-removebg-preview.png"
                    alt=""
                  />
                </button>
              </span>
            </div>
          </div>
        </div>
      </nav>
    </Sticky>



    <div
      id="balanceLimit"
      class="modal fade wallet-modal-root"
      tabindex="-1"
      role="dialog"
      aria-labelledby="balanceLimitTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered wallet-modal-dialog"
        role="document"
      >
        <div class="modal-content wallet-modal">
          <div class="wallet-modal__header">
            <h2
              id="balanceLimitTitle"
              class="wallet-modal__title"
            >
              <i
                class="fas fa-exclamation-circle wallet-modal__title-icon"
                aria-hidden="true"
              ></i>
              ဂိမ်းပိုက်ဆံအိတ် လက်ကျန် နည်းပါးခြင်း
            </h2>
            <button
              type="button"
              class="wallet-modal__close"
              data-dismiss="modal"
              :aria-label="$store.state.language === 'en' ? 'Close' : 'ပိတ်မည်'"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body wallet-modal__body">
            <p class="wallet-modal__lead">
              သင့်ဂိမ်းပိုက်ဆံအိတ်လက်ကျန်ငွေသည် ၁၀၀၀ ကျပ်အောက်လျော့နည်းနေပါသဖြင့် ပင်မပိုက်ဆံအိတ်မှ ငွေလွှဲပေးပါ။
            </p>
            <div
              class="wallet-modal__balances"
              role="group"
              aria-label="ပိုက်ဆံအိတ် လက်ကျန်များ"
            >
              <div class="wallet-modal__balance-row">
                <span class="wallet-modal__balance-label">ပင်မ ပိုက်ဆံအိတ်</span>
                <span
                  class="wallet-modal__balance-arrow"
                  aria-hidden="true"
                >
                  <i class="fas fa-long-arrow-alt-right"></i>
                </span>
                <span class="wallet-modal__balance-value">
                  K {{ Number($store.state.authUser.amount).toLocaleString() }}
                </span>
              </div>
              <div class="wallet-modal__balance-row">
                <span class="wallet-modal__balance-label">ဂိမ်း ပိုက်ဆံအိတ်</span>
                <span
                  class="wallet-modal__balance-arrow"
                  aria-hidden="true"
                >
                  <i class="fas fa-long-arrow-alt-right"></i>
                </span>
                <span
                  class="wallet-modal__balance-value"
                  :class="$store.state.authUser.game_balance > 0 ? 'wallet-modal__balance-value--ok' : 'wallet-modal__balance-value--low'"
                >
                  K {{ Number($store.state.authUser.game_balance).toLocaleString() }}
                </span>
              </div>
            </div>
            <button
              type="button"
              class="btn wallet-modal__btn-primary"
              @click="openMainToGame()"
            >
              ငွေလွှဲမည်
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="mainWallet"
      class="modal fade wallet-modal-root"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainWalletTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg wallet-modal-dialog wallet-modal-dialog--wide"
        role="document"
      >
        <div class="modal-content wallet-modal">
          <div class="wallet-modal__header">
            <h2
              id="mainWalletTitle"
              class="wallet-modal__title"
            >
              <i
                class="fas fa-wallet wallet-modal__title-icon"
                aria-hidden="true"
              ></i>
              ပင်မ ပိုက်ဆံအိတ်
            </h2>
            <button
              type="button"
              class="wallet-modal__close"
              data-dismiss="modal"
              :aria-label="$store.state.language === 'en' ? 'Close' : 'ပိတ်မည်'"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body wallet-modal__body">
            <p class="wallet-modal__section-label">အသုံးပြုနိုင်သောနေရာများ</p>
            <div class="wallet-modal__feature-panel">
              <div class="wallet-modal__feature-group">
                <h3 class="wallet-modal__feature-group-label">
                  {{
                    $store.state.language === "en"
                      ? "Lottery & sports"
                      : "ထီနှင့် အားကစား"
                  }}
                </h3>
                <ul class="wallet-modal__feature-list wallet-modal__feature-list--grid">
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon"
                        src="https://storage.googleapis.com/spacetech2/mdl/Lottery.png"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "2D / 3D lottery"
                          : "နှစ်လုံးထီ / သုံးလုံးထီ"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Play from main wallet"
                          : "ပင်မပိုက်ဆံအိတ်ဖြင့် ကစားနိုင်သည်"
                      }}</span>
                    </div>
                  </li>
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon"
                        src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/f8351d45-e73b-41d8-e32a-4a55ffd46900/public"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Football"
                          : "ဘောလုံး"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Football betting & markets"
                          : "ဘောလုံးထီ နှင့် ဈေးကွက်များ"
                      }}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="wallet-modal__feature-group wallet-modal__feature-group--divider">
                <h3 class="wallet-modal__feature-group-label">
                  {{
                    $store.state.language === "en"
                      ? "Wallet & cash"
                      : "ပိုက်ဆံ လွှဲပြောင်းမှု"
                  }}
                </h3>
                <ul class="wallet-modal__feature-list wallet-modal__feature-list--grid">
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap wallet-modal__feature-icon-wrap--symbol"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon wallet-modal__feature-icon--symbol"
                        src="https://www.seinlucky123.com/_nuxt/img/transfer_icon_detail.f5061b4.svg"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Transfer to game wallet"
                          : "ဂိမ်းပိုက်ဆံအိတ်သို့ လွှဲခြင်း"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Move balance for slots & fishing"
                          : "စလော့၊ ငါးပစ် ဂိမ်းများအတွက် ငွေလွှဲပါ"
                      }}</span>
                    </div>
                  </li>
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap wallet-modal__feature-icon-wrap--symbol"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon wallet-modal__feature-icon--symbol"
                        src="https://www.seinlucky123.com/_nuxt/img/transfer_icon_detail.f5061b4.svg"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Deposit & withdraw"
                          : "ငွေသွင်း / ငွေထုတ်"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Top up or cash out (main wallet)"
                          : "ငွေဖြည့်ခြင်း သို့ငွေထုတ်ယူခြင်း (ပင်မပိုက်ဆံအိတ်)"
                      }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="wallet-modal__balances"
              role="group"
              aria-label="ပိုက်ဆံအိတ် လက်ကျန်များ"
            >
              <div class="wallet-modal__balance-row">
                <span class="wallet-modal__balance-label">ပင်မ ပိုက်ဆံအိတ်</span>
                <span
                  class="wallet-modal__balance-arrow"
                  aria-hidden="true"
                >
                  <i class="fas fa-long-arrow-alt-right"></i>
                </span>
                <span
                  class="wallet-modal__balance-value"
                  :class="$store.state.authUser.amount > 0 ? 'wallet-modal__balance-value--ok' : 'wallet-modal__balance-value--low'"
                >
                  K {{ Number($store.state.authUser.amount).toLocaleString() }}
                </span>
              </div>
              <div class="wallet-modal__balance-row">
                <span class="wallet-modal__balance-label">ဂိမ်း ပိုက်ဆံအိတ်</span>
                <span
                  class="wallet-modal__balance-arrow"
                  aria-hidden="true"
                >
                  <i class="fas fa-long-arrow-alt-right"></i>
                </span>
                <span class="wallet-modal__balance-value">
                  K {{ Number($store.state.authUser.game_balance).toLocaleString() }}
                </span>
              </div>
            </div>
            <p class="wallet-modal__section-label wallet-modal__section-label--spaced">ငွေလွှဲပြောင်းရန်</p>
            <div class="wallet-modal__transfer">
              <div class="wallet-modal__transfer-col">
                <span class="wallet-modal__transfer-heading">မှ</span>
                <select
                  v-model="wallet.from"
                  class="wallet-modal__select"
                >
                  <option value="Main">ပင်မ ပိုက်ဆံအိတ်</option>
                  <option value="Game">ဂိမ်း ပိုက်ဆံအိတ်</option>
                </select>
              </div>
              <div
                class="wallet-modal__transfer-mid"
                aria-hidden="true"
              >
                <i class="fas fa-long-arrow-alt-right"></i>
              </div>
              <div class="wallet-modal__transfer-col">
                <span class="wallet-modal__transfer-heading">သို့</span>
                <select
                  v-model="wallet.to"
                  class="wallet-modal__select"
                >
                  <option value="Main">ပင်မ ပိုက်ဆံအိတ်</option>
                  <option value="Game">ဂိမ်း ပိုက်ဆံအိတ်</option>
                </select>
              </div>
            </div>
            <label
              class="wallet-modal__amount-label"
              for="main-wallet-amount"
            >
              {{
                $store.state.language === "en" ? "Amount (K)" : "ပမာဏ (ကျပ်)"
              }}
            </label>
            <input
              id="main-wallet-amount"
              v-model="wallet.amount"
              type="number"
              class="form-control wallet-modal__amount-input"
              placeholder="0"
              min="0"
            />
            <button
              type="button"
              class="btn wallet-modal__btn-primary"
              :disabled="isConfirm"
              @click="transferBalance"
            >
              <span v-if="!isConfirm">{{
                $store.state.language === "en" ? "Confirm" : "အတည်ပြုမည်"
              }}</span>
              <Loading
                v-else
                color="#1a1d26"
                size="24"
                class="wallet-modal__loading"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="gameWallet"
      class="modal fade wallet-modal-root"
      tabindex="-1"
      role="dialog"
      aria-labelledby="gameWalletTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg wallet-modal-dialog wallet-modal-dialog--wide"
        role="document"
      >
        <div class="modal-content wallet-modal">
          <div class="wallet-modal__header">
            <h2
              id="gameWalletTitle"
              class="wallet-modal__title"
            >
              <i
                class="fas fa-gamepad wallet-modal__title-icon"
                aria-hidden="true"
              ></i>
              ဂိမ်း ပိုက်ဆံအိတ်
            </h2>
            <button
              type="button"
              class="wallet-modal__close"
              data-dismiss="modal"
              :aria-label="$store.state.language === 'en' ? 'Close' : 'ပိတ်မည်'"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body wallet-modal__body">
            <p class="wallet-modal__section-label">အသုံးပြုနိုင်သောနေရာများ</p>
            <div class="wallet-modal__feature-panel">
              <div class="wallet-modal__feature-group">
                <h3 class="wallet-modal__feature-group-label">
                  {{
                    $store.state.language === "en"
                      ? "Casino games"
                      : "ဂိမ်းများ"
                  }}
                </h3>
                <ul
                  class="wallet-modal__feature-list wallet-modal__feature-list--grid wallet-modal__feature-list--grid-3"
                >
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon"
                        src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/77d739a7-33dc-49df-0764-0c307fb68200/public"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Slots"
                          : "စလော့ ဂိမ်းများ"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Use your game wallet balance"
                          : "ဂိမ်းပိုက်ဆံအိတ်ဖြင့် ကစားနိုင်သည်"
                      }}</span>
                    </div>
                  </li>
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon"
                        src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/37918220-37cf-4ddc-97de-2df2fbde8c00/public"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Fishing"
                          : "ငါးပစ် ဂိမ်းများ"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Fishing arcade games"
                          : "ငါးပစ်ဂိမ်းများတွင် အသုံးပြုနိုင်သည်"
                      }}</span>
                    </div>
                  </li>
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon"
                        src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/4a16e751-6e4e-4ff1-06de-509139d41200/public"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Card games"
                          : "ဖဲ ဂိမ်းများ"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Table and card titles"
                          : "ဖဲနှင့် ကတ်ဂိမ်းများ"
                      }}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="wallet-modal__feature-group wallet-modal__feature-group--divider">
                <h3 class="wallet-modal__feature-group-label">
                  {{
                    $store.state.language === "en"
                      ? "Wallet transfer"
                      : "ပိုက်ဆံ လွှဲပြောင်းမှု"
                  }}
                </h3>
                <ul class="wallet-modal__feature-list">
                  <li class="wallet-modal__feature-item">
                    <div
                      class="wallet-modal__feature-icon-wrap wallet-modal__feature-icon-wrap--symbol"
                      aria-hidden="true"
                    >
                      <img
                        class="wallet-modal__feature-icon wallet-modal__feature-icon--symbol"
                        src="https://www.seinlucky123.com/_nuxt/img/transfer_icon_detail.f5061b4.svg"
                        alt=""
                      />
                    </div>
                    <div class="wallet-modal__feature-copy">
                      <span class="wallet-modal__feature-title">{{
                        $store.state.language === "en"
                          ? "Move balance"
                          : "ပိုက်ဆံ လွှဲပြောင်းခြင်း"
                      }}</span>
                      <span class="wallet-modal__feature-meta">{{
                        $store.state.language === "en"
                          ? "Between main wallet and game wallet"
                          : "ပင်မနှင့် ဂိမ်းပိုက်ဆံအိတ်ကြား ငွေလွှဲနိုင်သည်"
                      }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="wallet-modal__balances"
              role="group"
              aria-label="ပိုက်ဆံအိတ် လက်ကျန်များ"
            >
              <div class="wallet-modal__balance-row">
                <span class="wallet-modal__balance-label">ပင်မ ပိုက်ဆံအိတ်</span>
                <span
                  class="wallet-modal__balance-arrow"
                  aria-hidden="true"
                >
                  <i class="fas fa-long-arrow-alt-right"></i>
                </span>
                <span class="wallet-modal__balance-value">
                  K {{ Number($store.state.authUser.amount).toLocaleString() }}
                </span>
              </div>
              <div class="wallet-modal__balance-row">
                <span class="wallet-modal__balance-label">ဂိမ်း ပိုက်ဆံအိတ်</span>
                <span
                  class="wallet-modal__balance-arrow"
                  aria-hidden="true"
                >
                  <i class="fas fa-long-arrow-alt-right"></i>
                </span>
                <span
                  class="wallet-modal__balance-value"
                  :class="$store.state.authUser.game_balance > 0 ? 'wallet-modal__balance-value--ok' : 'wallet-modal__balance-value--low'"
                >
                  K {{ Number($store.state.authUser.game_balance).toLocaleString() }}
                </span>
              </div>
            </div>
            <p class="wallet-modal__section-label wallet-modal__section-label--spaced">ငွေလွှဲပြောင်းရန်</p>
            <div class="wallet-modal__transfer">
              <div class="wallet-modal__transfer-col">
                <span class="wallet-modal__transfer-heading">မှ</span>
                <select
                  v-model="wallet.from"
                  class="wallet-modal__select"
                >
                  <option value="Main">ပင်မ ပိုက်ဆံအိတ်</option>
                  <option value="Game">ဂိမ်း ပိုက်ဆံအိတ်</option>
                </select>
              </div>
              <div
                class="wallet-modal__transfer-mid"
                aria-hidden="true"
              >
                <i class="fas fa-long-arrow-alt-right"></i>
              </div>
              <div class="wallet-modal__transfer-col">
                <span class="wallet-modal__transfer-heading">သို့</span>
                <select
                  v-model="wallet.to"
                  class="wallet-modal__select"
                >
                  <option value="Main">ပင်မ ပိုက်ဆံအိတ်</option>
                  <option value="Game">ဂိမ်း ပိုက်ဆံအိတ်</option>
                </select>
              </div>
            </div>
            <label
              class="wallet-modal__amount-label"
              for="game-wallet-amount"
            >
              {{
                $store.state.language === "en" ? "Amount (K)" : "ပမာဏ (ကျပ်)"
              }}
            </label>
            <input
              id="game-wallet-amount"
              v-model="wallet.amount"
              type="number"
              class="form-control wallet-modal__amount-input"
              placeholder="0"
              min="0"
            />
            <button
              type="button"
              class="btn wallet-modal__btn-primary"
              :disabled="isConfirm"
              @click="transferBalance"
            >
              <span v-if="!isConfirm">{{
                $store.state.language === "en" ? "Confirm" : "အတည်ပြုမည်"
              }}</span>
              <Loading
                v-else
                color="#1a1d26"
                size="24"
                class="wallet-modal__loading"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Sticky, Loading },
  data() {
    return {
      messages: [],
      wallet: {
        to: 'Main',
        from: 'Game',
        amount: 0,
      },
      showTop: false,
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
      isConfirm: false,
    };
  },
  watch: {
    'wallet.to': function () {
      if (this.wallet.to === 'Main') {
        this.wallet.from = 'Game';
      } else {
        this.wallet.from = 'Main';
      }
    },
    'wallet.from': function () {
      if (this.wallet.from === 'Main') {
        this.wallet.to = 'Game';
      } else {
        this.wallet.to = 'Main';
      }
    },
  },
  methods: {
    appInstall() {
      const ua = navigator.userAgent || navigator.vendor || '';
      const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const isAndroid = /Android/i.test(ua);
      const iosUrl = 'https://back.mandalarthu.com/api/app/download/ios';
      const androidUrl = 'https://back.mandalarthu.com/api/app/download/android';
      if (isIOS) {
        window.open(iosUrl, '_blank', 'noopener,noreferrer');
      } else if (isAndroid) {
        window.open(androidUrl, '_blank', 'noopener,noreferrer');
      } else {
        const msg = this.$store.state.language === 'en' ? 'Device not match' : 'ကိရိယာ မကိုက်ညီပါ';
        alert(msg);
      }
    },
    openMainToGame() {
      $('#balanceLimit').modal('hide');
      $('#gameWallet').modal('show')
    },
    async transferBalance() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          this.isConfirm = true;
          const res = await axios.post(
            "/transferWallet",
            this.wallet, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
          );

          Toast.success(
            'Success!'
          );
          await this.fetchUser();
          this.wallet.amount = 0;
          this.isConfirm = false;
        })
        .catch((error) => {
          this.isConfirm = false;
          let errorMessage = null;
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
            Dialog.alert({
              message: errorMessage,
              confirmButtonText:
                this.$store.state.language === 'en'
                  ? 'Go Back'
                  : 'နောက်သို့ပြန်သွားမည်။',
            })
          }


        });
    },
    showGameWallet() {
      $('#gameWallet').modal('show');
      this.wallet.from = 'Main';
      this.wallet.amount = 0;
    },
    showMainWallet() {
      $('#mainWallet').modal('show');
      this.wallet.from = 'Game';
      this.wallet.amount = 0;
    },
    timeFormat(time) {
      return moment(time).startOf('hour').fromNow();
    },
    async getMessages() {
      try {
        const res = await axios.get('/messages');
        this.messages = res.data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showTopImage() {
      this.showTop = !this.showTop;
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === 'granted') {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission granted!'
              : 'အသိပေးချက်အတည်ပြုပြီးပြီ'
          );
        } else {
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission denied!'
              : 'အသိပေးချက်အတည်ပြုမပြီးပြီ'
          );
        }
      });
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            this.$router.go();
          } else {
            this.$router.push('/home');
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    closeNavCollapse() {
      $('#navbar-default').collapse('hide');
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
      $('#navbar-default').collapse('hide');
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => { });
      $('#navbar-default').collapse('hide');
    },
    redirectRoute(path) {
      if (path === '2d') {
        this.$router.push('/user/2d');
      } else {
        this.$router.push('/user/3d');
      }
      return true;
    },
  },
  async mounted() {
    // this.getMessages();
    // if(window.Notification.permission === 'granted') {
    //   this.alreadyGranted = false;
    // }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  }
};
</script>
<style scoped>
.login-btn {
  background: transparent;
  border: 1px solid #d02126;
  border-radius: 3px;
  padding: 0.3rem 1.5rem;
  color: #d02126;
}

.coin {
  height: 1.3rem;
  margin-top: -0.25rem;
  margin-right: 0.4rem;
  animation: flip-coin-49989627 2.5s linear infinite;
  transform-style: preserve-3d;
}

@keyframes flip-coin-49989627 {
  0% {
    transform: rotateY(0deg);
  }

  50% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(360deg);
  }
}

.navbar-app {
  --nav-bg: #1d1f26;
  --nav-border: rgba(255, 255, 255, 0.1);
  --nav-chip: rgba(255, 255, 255, 0.09);
  --nav-chip-hover: rgba(255, 255, 255, 0.13);
  --nav-muted: #9aa3b8;
  --nav-gold: #efdb01;
  --nav-accent: #46f49b;

  background: var(--nav-bg);
  border: none;
  border-bottom: 1px solid #323743;
  box-shadow: none;
  padding: 0.38rem 0.55rem;
  min-height: 2.95rem;
}

.navbar-app-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem 0.55rem;
  padding-left: 0.15rem;
  padding-right: 0.15rem;
}

.navbar-app-left {
  display: flex;
  align-items: center;
  gap: 0.28rem;
  min-width: 0;
  flex: 0 1 auto;
}

.navbar-back {
  flex-shrink: 0;
  width: 2.15rem;
  height: 2.15rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--nav-chip);
  color: var(--nav-muted);
  transition: background 0.15s ease, color 0.15s ease, transform 0.12s ease;
  cursor: pointer;
  padding: 0;
}

.navbar-back:hover {
  background: var(--nav-chip-hover);
  color: #cfd6f1;
}

.navbar-back:active {
  transform: scale(0.96);
}

.navbar-back:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(70, 244, 155, 0.35);
}

.navbar-logo-wrap {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  border-radius: 0.3rem;
  line-height: 0;
  transition: opacity 0.15s ease;
}

.navbar-logo-wrap:hover {
  opacity: 0.92;
}

.navbar-logo-wrap:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(70, 244, 155, 0.35);
}

.navbar-logo {
  width: 5.15rem;
  height: auto;
  max-height: 2.28rem;
  object-fit: contain;
  display: block;
}

.navbar-app-right {
  display: flex;
  align-items: stretch;
  gap: 0.35rem;
  flex: 1 1 auto;
  justify-content: flex-end;
  min-width: 0;
}

.navbar-avatar-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-right: 0.15rem;
}

.navbar-avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(70, 244, 155, 0.45);
  box-shadow: none;
}

.navbar-wallet {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.06rem;
  padding: 0.28rem 0.5rem;
  min-width: 0;
  max-width: 11rem;
  border-radius: 0.4rem;
  background: var(--nav-chip);
  border: 1px solid var(--nav-border);
  transition: background 0.15s ease, border-color 0.15s ease;
}

.navbar-wallet:hover {
  background: var(--nav-chip-hover);
  border-color: rgba(70, 244, 155, 0.2);
}

.navbar-wallet-label {
  font-size: 0.65rem;
  font-weight: 700;
  color: #e8ecf4;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-wallet-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
}

.navbar-wallet-amount {
  font-size: 0.825rem;
  font-weight: 700;
  color: var(--nav-gold);
  letter-spacing: 0.02em;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-transfer-btn {
  flex-shrink: 0;
  width: 1.6rem;
  height: 1.6rem;
  padding: 0;
  border: none;
  border-radius: 0.3rem;
  background: rgba(255, 255, 255, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.12s ease;
}

.navbar-transfer-btn:hover {
  background: rgba(255, 255, 255, 0.14);
}

.navbar-transfer-btn:active {
  transform: scale(0.94);
}

.navbar-transfer-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(239, 219, 1, 0.35);
}

.navbar-transfer-btn img {
  width: 1rem;
  height: auto;
  display: block;
}

.nav-link {
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
}

.bg-default {
  background-color: #02133e !important;
}

@media (max-width: 575.98px) {
  .navbar-app {
    padding: 0.32rem 0.38rem;
    min-height: 2.78rem;
  }

  .navbar-app-inner {
    gap: 0.35rem;
  }

  .navbar-logo {
    width: 4.55rem;
    max-height: 2.05rem;
  }

  .navbar-app-right {
    flex-wrap: nowrap;
    gap: 0.3rem;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    max-width: 100%;
    flex: 1 1 0;
    justify-content: flex-end;
  }

  .navbar-app-right::-webkit-scrollbar {
    display: none;
  }

  .navbar-wallet {
    flex: 0 0 auto;
    max-width: 9.5rem;
    padding: 0.24rem 0.42rem;
  }

  .navbar-wallet-label {
    font-size: 0.6rem;
  }

  .navbar-wallet-amount {
    font-size: 0.76rem;
  }

  .navbar-avatar {
    width: 2.05rem;
    height: 2.05rem;
  }

  .navbar-avatar-wrap {
    flex-shrink: 0;
  }
}

@media (max-width: 360px) {
  .navbar-back {
    width: 2rem;
    height: 2rem;
  }

  .navbar-wallet-label {
    font-size: 0.57rem;
  }

  .navbar-wallet-amount {
    font-size: 0.72rem;
  }
}

/* Wallet modals (#balanceLimit, #mainWallet) — scoped tokens match navbar-app */
.wallet-modal-dialog {
  max-width: min(34rem, calc(100vw - 1.25rem));
  margin: 0.75rem auto;
}

.wallet-modal-dialog--wide {
  max-width: min(46rem, calc(100vw - 1.25rem));
}

.wallet-modal {
  background: linear-gradient(165deg, #2a2e3a 0%, #1a1d26 55%, #14161c 100%);
  border: none !important;
  border-radius: 1rem;
  box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.55);
  overflow: hidden;
  color: #e8eaef;
}

.wallet-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1rem 0.65rem;
}

.wallet-modal__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.35;
  color: #fff;
  text-align: left;
  flex: 1;
  padding-right: 0.25rem;
}

.wallet-modal__title-icon {
  color: #efdb01;
  margin-right: 0.4rem;
  font-size: 0.95em;
  vertical-align: -0.05em;
}

.wallet-modal__close {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  padding: 0;
  margin: -0.2rem -0.2rem 0 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.wallet-modal__close:hover {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.wallet-modal__body {
  padding: 1rem 1.1rem 1.25rem;
}

.wallet-modal__lead {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  line-height: 1.55;
  color: rgba(232, 234, 239, 0.92);
  text-align: left;
}

.wallet-modal__section-label {
  margin: 0 0 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #efdb01;
  text-align: left;
}

.wallet-modal__section-label--spaced {
  margin-top: 1.35rem;
  padding-top: 0.25rem;
}

.wallet-modal__feature-panel {
  margin: 0 0 1.1rem;
  padding: 0.85rem 0.75rem 0.65rem;
  background: rgba(0, 0, 0, 0.22);
  border: none;
  border-radius: 0.85rem;
}

.wallet-modal__feature-group {
  margin: 0;
}

.wallet-modal__feature-group--divider {
  margin-top: 1rem;
  padding-top: 0.25rem;
}

.wallet-modal__feature-group-label {
  margin: 0 0 0.55rem;
  padding: 0 0.15rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(239, 219, 1, 0.95);
  text-align: left;
  line-height: 1.3;
}

.wallet-modal__feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.wallet-modal__feature-list--grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.6rem;
}

@media (min-width: 400px) {
  .wallet-modal__feature-list--grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.55rem 0.65rem;
    align-items: stretch;
  }
}

@media (min-width: 520px) {
  .wallet-modal__feature-list--grid.wallet-modal__feature-list--grid-3 {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.5rem 0.55rem;
  }
}

.wallet-modal__feature-item {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.65rem 0.7rem;
  min-height: 100%;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.7rem;
  border: none;
  text-align: left;
  transition: background 0.15s ease;
}

.wallet-modal__feature-item:hover {
  background: rgba(255, 255, 255, 0.09);
}

.wallet-modal__feature-icon-wrap {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  background: linear-gradient(145deg,
      rgba(70, 244, 155, 0.14) 0%,
      rgba(255, 255, 255, 0.06) 100%);
  border: none;
}

.wallet-modal__feature-icon-wrap--symbol {
  background: linear-gradient(145deg,
      rgba(239, 219, 1, 0.14) 0%,
      rgba(255, 255, 255, 0.05) 100%);
}

.wallet-modal__feature-icon {
  width: 2.35rem;
  height: 2.35rem;
  object-fit: contain;
}

.wallet-modal__feature-icon--symbol {
  width: 1.65rem;
  height: 1.65rem;
}

.wallet-modal__feature-copy {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding-top: 0.05rem;
}

.wallet-modal__feature-title {
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.35;
  color: #fff;
}

.wallet-modal__feature-meta {
  font-size: 0.72rem;
  line-height: 1.45;
  color: rgba(232, 234, 239, 0.62);
}

.wallet-modal__balances {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.65rem 0.75rem;
  background: rgba(0, 0, 0, 0.28);
  border-radius: 0.75rem;
  border: none;
}

.wallet-modal__balance-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.35rem 0.5rem;
  font-size: 0.86rem;
}

.wallet-modal__balance-label {
  color: #46f49b;
  font-weight: 600;
  text-align: left;
}

.wallet-modal__balance-arrow {
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.85rem;
  display: flex;
  justify-content: center;
}

.wallet-modal__balance-value {
  font-weight: 700;
  color: #fff;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.wallet-modal__balance-value--ok {
  color: #46f49b;
}

.wallet-modal__balance-value--low {
  color: #ff6b6b;
}

.wallet-modal__transfer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem 0.35rem;
  margin-bottom: 0.85rem;
}

.wallet-modal__transfer-col {
  flex: 1 1 38%;
  min-width: 6.5rem;
}

.wallet-modal__transfer-mid {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.55rem;
  color: rgba(255, 255, 255, 0.5);
  font-size: 1rem;
}

.wallet-modal__transfer-heading {
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  color: #efdb01;
  margin-bottom: 0.35rem;
  text-align: center;
}

.wallet-modal__select {
  width: 100%;
  height: 2.5rem;
  padding: 0 0.65rem;
  border-radius: 0.65rem;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 0.82rem;
  box-shadow: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%239aa3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.65rem center;
  padding-right: 1.75rem;
}

.wallet-modal__select:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(70, 244, 155, 0.35);
}

.wallet-modal__amount-label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(232, 234, 239, 0.75);
  text-align: left;
}

.wallet-modal__amount-input {
  border-radius: 0.65rem !important;
  border: none !important;
  background: rgba(255, 255, 255, 0.1) !important;
  color: #46f49b !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  height: 2.65rem !important;
  box-shadow: none !important;
  margin-bottom: 1rem !important;
}

.wallet-modal__amount-input::placeholder {
  color: rgba(70, 244, 155, 0.35);
}

.wallet-modal__amount-input:focus {
  box-shadow: 0 0 0 2px rgba(70, 244, 155, 0.3) !important;
}

.wallet-modal__btn-primary {
  width: 100%;
  padding: 0.65rem 1rem;
  border: none;
  border-radius: 0.65rem;
  background: linear-gradient(180deg, #5ef4a8 0%, #46f49b 100%);
  color: #1a1d26 !important;
  font-weight: 700;
  font-size: 0.95rem;
  box-shadow: 0 4px 14px rgba(70, 244, 155, 0.25);
  transition: transform 0.12s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.wallet-modal__btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(70, 244, 155, 0.32);
}

.wallet-modal__btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.wallet-modal__btn-primary:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.wallet-modal__loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.5rem;
}
</style>
